import { useState, useEffect } from 'react';
import './Loader.css';

export default function Loader({ onComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      const timer = setTimeout(() => onComplete(), 400);
      return () => clearTimeout(timer);
    }
  }, [progress, onComplete]);

  return (
    <div className="loader">
      <div className="loader__content">
        <div className="loader__orbit">
          {/* Outer ring */}
          <div className="loader__ring loader__ring--outer">
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
          </div>
          {/* Middle ring */}
          <div className="loader__ring loader__ring--middle">
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
            <span className="loader__dot" />
          </div>
          {/* Inner ring */}
          <div className="loader__ring loader__ring--inner">
            <span className="loader__dot" />
            <span className="loader__dot" />
          </div>
          {/* Center logo */}
          <div className="loader__center">
            <span className="loader__logo">IWX</span>
          </div>
        </div>

        <div className="loader__info">
          <div className="loader__progress">
            <div className="loader__progress-track">
              <div className="loader__progress-fill" style={{ width: `${progress}%` }} />
            </div>
          </div>
          <p className="loader__caption">Loading experience...</p>
        </div>
      </div>
    </div>
  );
}
